/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GameStatsResponse
 */
export interface GameStatsResponse {
    /**
     * The game ID (MongoDB ObjectId of the OWGame)
     * @type {string}
     * @memberof GameStatsResponse
     */
    gameId?: string;
    /**
     * The Overwolf game ID string (e.g. "21566")
     * @type {string}
     * @memberof GameStatsResponse
     */
    overwolfGameId?: string;
    /**
     * Total XP earned for this game in the time period (includes multipliers)
     * @type {number}
     * @memberof GameStatsResponse
     */
    xpEarned?: number;
    /**
     * Time played in minutes for this game
     * @type {number}
     * @memberof GameStatsResponse
     */
    timePlayed?: number;
    /**
     * Number of play sessions for this game
     * @type {number}
     * @memberof GameStatsResponse
     */
    sessionsCount?: number;
    /**
     * Last time the user played this game
     * @type {Date}
     * @memberof GameStatsResponse
     */
    lastPlayed?: Date;
    /**
     * The time filter applied
     * @type {string}
     * @memberof GameStatsResponse
     */
    timeFilter?: string;
}

/**
 * Check if a given object implements the GameStatsResponse interface.
 */
export function instanceOfGameStatsResponse(value: object): value is GameStatsResponse {
    return true;
}

export function GameStatsResponseFromJSON(json: any): GameStatsResponse {
    return GameStatsResponseFromJSONTyped(json, false);
}

export function GameStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'overwolfGameId': json['overwolfGameId'] == null ? undefined : json['overwolfGameId'],
        'xpEarned': json['xpEarned'] == null ? undefined : json['xpEarned'],
        'timePlayed': json['timePlayed'] == null ? undefined : json['timePlayed'],
        'sessionsCount': json['sessionsCount'] == null ? undefined : json['sessionsCount'],
        'lastPlayed': json['lastPlayed'] == null ? undefined : (new Date(json['lastPlayed'])),
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
    };
}

export function GameStatsResponseToJSON(json: any): GameStatsResponse {
    return GameStatsResponseToJSONTyped(json, false);
}

export function GameStatsResponseToJSONTyped(value?: GameStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'overwolfGameId': value['overwolfGameId'],
        'xpEarned': value['xpEarned'],
        'timePlayed': value['timePlayed'],
        'sessionsCount': value['sessionsCount'],
        'lastPlayed': value['lastPlayed'] == null ? undefined : ((value['lastPlayed']).toISOString()),
        'timeFilter': value['timeFilter'],
    };
}

